import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../Privacy/Privacy.scss";
import DynamicHeader from "../../Header/DynamicHeader";
import categoryFieldsConfig from "../../CreateListing/categoryFieldsConfig";

// SEO Phase 3 (Brand/Entity/AI discoverability) — the site had no public
// page stating in plain, factual language what Cvanto actually is. Every
// sentence here is either already established elsewhere (the WebSite
// JSON-LD description on Home.js, the real category list
// categoryFieldsConfig.js defines) or a plain factual restatement of the
// product's own real feature set (communities, buy/sell/exchange/give
// away) — nothing invented, no claimed user counts or ratings.
const About = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || "support@cvanto.com";
  const categories = Object.keys(categoryFieldsConfig);

  return (
    <>
      <Helmet>
        <title>Про Cvanto — соціальний маркетплейс України</title>
        <meta
          name="description"
          content="Cvanto — соціальний маркетплейс України: купівля, продаж, обмін і безкоштовна віддача речей та послуг, спілкування в тематичних спільнотах."
        />
        <link rel="canonical" href="https://cvanto.com/about" />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Cvanto" />
        <meta property="og:title" content="Про Cvanto — соціальний маркетплейс України" />
        <meta
          property="og:description"
          content="Cvanto — соціальний маркетплейс України: купівля, продаж, обмін і безкоштовна віддача речей та послуг, спілкування в тематичних спільнотах."
        />
        <meta property="og:url" content="https://cvanto.com/about" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "Про Cvanto",
            url: "https://cvanto.com/about",
            about: {
              "@type": "Organization",
              name: "Cvanto",
              alternateName: ["Кванто", "кванто"],
              url: "https://cvanto.com",
            },
          })}
        </script>
      </Helmet>

      <DynamicHeader title="Про Cvanto" variant="glass" size="regular" showBack withSpacer />

      <div className="legal">
        <header className="legal__hero">
          <h1 className="legal__title">Про Cvanto</h1>
          <p>
            Cvanto (Кванто) — соціальний маркетплейс України. Тут можна купувати, продавати,
            обмінювати й безкоштовно віддавати речі та послуги, а також спілкуватися в тематичних
            спільнотах з людьми зі схожими інтересами.
          </p>
        </header>

        <section>
          <h2>Що можна робити на Cvanto</h2>
          <ul>
            <li>Розміщувати оголошення про продаж, обмін або безкоштовну віддачу</li>
            <li>Шукати товари й послуги за категорією та містом</li>
            <li>Спілкуватися з продавцями та покупцями напряму в чаті</li>
            <li>Приєднуватись до тематичних спільнот або створювати власні</li>
            <li>Вести бізнес-профіль із каталогом товарів, послуг і вакансій</li>
          </ul>
        </section>

        <section>
          <h2>Категорії</h2>
          <p>{categories.join(" · ")}</p>
        </section>

        <section>
          <h2>Контакти</h2>
          <p>
            Технічна підтримка: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>. Детальніше —{" "}
            <Link to="/settings/help">Допомога та техпідтримка</Link>.
          </p>
          <p>
            <Link to="/terms">Правила спільноти</Link> · <Link to="/privacy">Політика конфіденційності</Link>
          </p>
        </section>
      </div>
    </>
  );
};

export default About;
